<!--
 * @Description: 
 * @Date: 2024-01-11 14:07:13
-->
<template>
  <div class="top">
    <div class="t_name">
      <p class="cn">目录</p>
      <p class="en">contents</p>
      <div class="hr"></div>
    </div>
    <p class="detail">
      本报告所依赖数据都来自于线上或线下真实发生的行为所产生的数据，本次用于生成报告的数据为
      {{ taskSum }} 份。
    </p>
  </div>

  <div class="item" v-for="({ title, child }, index) in catalogue" :key="index">
    <div class="index">{{ `${index + 1}`.padStart(2, '0') }}</div>
    <div class="name">{{ title }}</div>
    <div class="child" v-if="Array.isArray(child)">
      <div
        class="child-item"
        v-for="({ title, num }, childIndex) in child"
        :key="childIndex"
      >
        <p class="child-item-name">{{ title }}</p>
        <p class="child-item-number">
          {{ `${num}`.padStart(2, '0') }}
        </p>
      </div>
    </div>
  </div>
</template>

<script setup lang="tsx">
import { watch } from 'vue';
type CataLogueType = Array<{
  title: string;
  num: number;
  child: CataLogueType;
}>;
const props = withDefaults(
  defineProps<{ taskSum?: number; catalogue: CataLogueType }>(),
  {
    taskSum: 1
  }
);
const emits = defineEmits(['catalogueFinish']);
watch(
  () => props.catalogue,
  () => {
    emits('catalogueFinish');
  }
);
</script>
<style lang="scss" scoped>
@import './index.scss';
.t_name {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  font-weight: 500;
  line-height: 1.4;
  color: #0f0f0f;
  padding-bottom: 40px;
  .cn {
    font-size: 50px;
  }
  .en {
    font-size: 52px;
    text-transform: capitalize;
    padding-left: 12px;
  }
  .hr {
    width: 100%;
    padding-top: 24px;
    border-bottom: 34px solid var(--theme-color-1);
  }
}
.detail {
  padding-top: 40px;
  padding-bottom: 40px;
  font-size: 16px;
  font-weight: 500;
  line-height: 1.6;
  color: #3e3e3e;
}

$left: 110px;
.item {
  padding: 20px 0;
  padding-bottom: 40px;
  padding-left: $left;
  position: relative;
  &::before {
    $width: 6px;
    content: '';
    width: $width;
    height: $width;
    background-color: #142666;
    transform: rotate(45deg);
    position: absolute;
    left: 0;
    bottom: 10px;
    box-shadow: ($width + 1pt) (-$width - 1pt) 0 #142666,
      ($width + 1pt) * 2 (-$width - 1pt) * 2 0 #142666;
  }
  &::after {
    $width: 35px;
    content: '';
    width: calc(200% - $width * 2);
    border: 2px dashed #142666;
    position: absolute;
    bottom: 11pt;
    left: $width;
    transform: scale(0.5);
    transform-origin: 0 50%;
  }
  .index {
    color: var(--theme-color-1);
    font-size: 50px;
    font-weight: 500;
    flex-shrink: 0;
    position: absolute;
    left: 0;
    width: 86px;
    height: 86px;
    &::after {
      content: '';
      width: 60px;
      height: 1pt;
      background-color: #707070;
      position: absolute;
      transform: rotate(-45deg);
      right: -9px;
      bottom: 9px;
    }
  }
  .name {
    font-size: 30px;
    font-weight: 500;
    line-height: 69px;
    color: #222222;
    @include line_clamp(1);
  }
  .child {
    .child-item {
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-size: 18px;
      font-weight: 500;
      color: #222222;
      padding: 12px 0;
    }
    .child-item-name {
      max-width: 60%;
      @include line_clamp(1);
    }
    .child-item-number {
    }
  }
}
</style>
